// src/oauthErrors.ts
// Classifies Firebase Auth error codes for the Google sign-in button
// (AuthModal.tsx). Same mapping as realmweb/src/oauthErrors.ts.

const BENIGN_CODES = new Set([
  'auth/popup-closed-by-user',
  'auth/cancelled-popup-request',
]);

/** True for errors the user caused themselves (closed the popup, opened another) — show nothing. */
export function isBenignOAuthError(code: string | undefined): boolean {
  return !!code && BENIGN_CODES.has(code);
}

/**
 * A specific, user-facing message for error codes that need one.
 * Returns undefined for anything without a tailored message — the caller
 * should fall back to the raw error's message, then a generic string.
 */
export function describeOAuthError(code: string | undefined): string | undefined {
  if (code === 'auth/popup-blocked') {
    return 'Your browser blocked the sign-in popup. Please allow popups for this site and try again.';
  }
  if (code === 'auth/account-exists-with-different-credential') {
    return 'An account already exists with this email using a different sign-in method. Please use that one instead.';
  }
  return undefined;
}
